import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';
import { HeaderSkeleton } from 'app/src/components/HeaderSkeleton';
import { Null } from 'app/src/components/Null';

export const LazyLoggedOutHeader: React.FunctionComponent = () => {
  const LoggedOutHeader = useLazyComponent(
    () =>
      import(/* webpackChunkName: "logged-out-header" */ './LoggedOutHeader'),
    { namedImport: 'LoggedOutHeader' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-teamplates',
        feature: 'Logged-Out Header',
      }}
      errorHandlerComponent={Null}
    >
      <ChunkLoadErrorBoundary fallback={<HeaderSkeleton />}>
        <Suspense fallback={<HeaderSkeleton />}>
          <LoggedOutHeader />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
